const BASE_URL = 'https://api.test.happer.fr/api'
// ### Base URLs
// - **Development:** `https://happer-test.francecentral.cloudapp.azure.com/`
// - **Production:** `https://happer-production.francecentral.cloudapp.azure.com/`
const APIS = {
    REGISTER_USER: BASE_URL + '/users/register',
    LOGIN_API: BASE_URL + '/users/login',
    GET_CATEGORIES_API: BASE_URL + '/selfies/influencer?category=',
    GET_DISCOVER_LITING: BASE_URL + '/selfies?category=',


    GET_ITEMS_BY_ID: BASE_URL + '/items/',
    GET_SELFIES_BY_ID: BASE_URL + '/selfies/',
    ADD_TO_CART_API: BASE_URL + '/carts/add',
    CHANGE_PASSWORD_API: BASE_URL + '/users/modify_password',
    PROFILE_WISH_LIST_API: BASE_URL + '/wishes/me',
    PRODUCT_WIN_API: BASE_URL + 'products/win',
    MY_PURCHASE_API: BASE_URL + '/carts/me/all',
    MY_IMAGES_PROFILE: BASE_URL + '/selfies/me',
    SEARCH_BAR_API: BASE_URL + 'selfies/influencer?page=',
    MODIFY_PASSWORD: BASE_URL + '/users/modify_password',
    FOR_ADDRESS_EDIT: BASE_URL + 'users/me',
    GET_CART_DATA: BASE_URL + '/carts/me',
    CART_ADDRESS_API: BASE_URL + '/carts/addresses',
    GET_PROFILE_DATA: BASE_URL + '/selfies/profile',
    GET_LIKED_DATA:BASE_URL+'/selfies/liked',
    GET_WIN_DATA:BASE_URL+'/products/win',
    GET_FOLLOW_USERS_COUNT:BASE_URL+'/follows/user/',
    GET_ADDRESS_API:BASE_URL+'/users/me',
    GET_NOTIFICATION:BASE_URL+'/notifications/user',
    




}

export {
    APIS, BASE_URL
}